module.exports = __webpack_public_path__ + "img/print-qr.9ced7425.svg";